/**
 * Absolute paths, used by links and by `navigate()`.
 *
 * The route tree declares its own segments relative to the dashboard layout;
 * these are what the rest of the app points at, so they stay absolute.
 */
export const LOGIN = '/';
export const DASHBOARD = '/dashboard';
export const ACCOUNT = '/account/:action';
export const ACCOUNT_PATH = '/account/';

export const DASHBOARD_HOME = `${DASHBOARD}`;
export const LEARNING = `${DASHBOARD}/learning`;
export const ACTIVITIES = `${DASHBOARD}/activities`;
export const SUPPORT = `${DASHBOARD}/support`;
export const MESSAGING_SMS = `${DASHBOARD}/messaging/sms`;
export const MESSAGING_EMAIL = `${DASHBOARD}/messaging/email`;
export const PROFILE = `${DASHBOARD}/profile`;
export const SETUP_USERS = `${DASHBOARD}/setup/users`;
export const SETUP_COHORT = `${DASHBOARD}/setup/cohort`;

// Cohorts
export const SETUP_COHORT_HOME = SETUP_COHORT;
export const SETUP_COHORT_DETAIL = `${SETUP_COHORT}/:id`;
export const cohortDetailPath = (id) => `${SETUP_COHORT}/${id}`;

// Users
export const SETUP_USER_HOME = SETUP_USERS;
export const SETUP_USER_NEW = `${SETUP_USERS}/new/:userType`;
export const SETUP_USER_DETAIL = `${SETUP_USERS}/detail/:id`;
export const newUserPath = (userType) => `${SETUP_USERS}/new/${userType}`;
export const userDetailPath = (id) => `${SETUP_USERS}/detail/${id}`;

// Learning
export const LEARNING_TOPIC = `${LEARNING}/:subjectId`;
export const LEARNING_TOPIC_CREATE = `${LEARNING}/topic/new`;
export const LEARNING_TOPIC_EDIT = `${LEARNING}/topic/edit`;
export const subjectTopicsPath = (subjectId) => `${LEARNING}/${subjectId}`;
/**
 * Both screens carry the subject in the query string, because a topic is
 * addressed within its subject — the API needs the pair, not the topic id
 * alone.
 */
export const newTopicPath = (subjectId) => `${LEARNING_TOPIC_CREATE}?sub=${subjectId}`;
export const editTopicPath = (subjectId, topicId) => `${LEARNING_TOPIC_EDIT}?sub=${subjectId}&topic=${topicId}`;

// Activities
export const ACTIVITY_SUBMISSIONS = `${ACTIVITIES}/:activityId`;
export const activitySubmissionsPath = (activityId) => `${ACTIVITIES}/${activityId}`;

// Messaging
export const CREATE_MESSAGE_SMS = `${MESSAGING_SMS}/new`;
export const CREATE_MESSAGE_EMAIL = `${MESSAGING_EMAIL}/new`;

// Student
export const STUDENT_HOME = `${DASHBOARD}/student/home`;
export const STUDENT_ACTIVITIES = `${DASHBOARD}/student/activities`;
export const STUDENT_SUPPORT = `${DASHBOARD}/student/support`;
export const STUDENT_PROFILE = `${DASHBOARD}/student/profile`;

export const STUDENT_HOME_SUBJECT = `${STUDENT_HOME}/cohort/:id`;
export const STUDENT_HOME_SUBJECT_LEARN = `${STUDENT_HOME_SUBJECT}/learn`;
export const studentCohortPath = (id) => `${STUDENT_HOME}/cohort/${id}`;
export const studentLearnPath = (cohortId, subjectId, topicId) => `${STUDENT_HOME}/cohort/${cohortId}/learn?sub=${subjectId}&topic=${topicId}`;

export const STUDENT_ACTIVITY_DETAILS = `${STUDENT_ACTIVITIES}/:id`;
export const studentActivityPath = (id) => `${STUDENT_ACTIVITIES}/${id}`;

export const STUDENT_SUPPORT_REPLY = `${STUDENT_SUPPORT}/:id`;
export const studentSupportReplyPath = (id) => `${STUDENT_SUPPORT}/${id}`;

/**
 * Which sidebar entry to highlight. The previous version read the segment at
 * index 1, which is always "dashboard" for these paths, so the highlight
 * never moved off the first item.
 */
export const sbTeacherMatchKey = (pathname) => {
  const [, , region] = pathname.split('/');
  switch (region) {
    case 'learning': return '2';
    case 'activities': return '3';
    case 'support': return '4';
    case 'messaging': return '5';
    case 'profile': return '6';
    case 'setup': return '7';
    default: return '1';
  }
};
